export default __webpack_public_path__ + "static/media/smartphone.b0a82cc0.jpg";